export enum WrapType {
  NotApplicable = 0,
  Wrap = 1,
  Unwrap = 2,
  FewWrap = 3,
  FewUnwrap = 4,
}
